import axios from "axios";

import {
  UserSession,
  dispatchAction,
  BrushResponse,
} from "./TypesAndConstants/types";
import { fetchDefaultSetting, getUserImages } from '../services/galleryService'

export class API {
  testImages = [
    "/art/6/82",
    "/art/6/83",
    "/art/6/84",
    "/art/6/85",
    "/art/6/86",
    "/art/6/87",
    "/art/6/88",
    "/art/6/90",
    "/art/6/91",
    "/art/6/12206",
    "/art/6/12211",
    "/art/6/44046",
    "/art/6/44047",
  ];

  private intialCredentialFetch = async (): Promise<UserSession> => {
    return axios
      .request({
        url: "https://www.artthread.org/Splash2/GetUserCredentials.php",
        method: "GET",
        withCredentials: true,
      })
      .then((resp) => {
        return resp.data;
      })
      .catch((e) => console.log(e));
  };

  private getUserBrushes = async (): Promise<BrushResponse> => {
    return axios
      .request({
        url: "https://www.artthread.org/Splash2/FetchBrushSettings.php",
        method: "GET",
        withCredentials: true,
      })
      .then((resp) => {
        return resp.data;
      })
      .catch((e) => console.log(e));
  };

  private parseBrushResponse = (resp: string) => {
    if (resp[0] === "[") {
      return JSON.parse(resp);
    } else {
      if (resp[0] === "n") {
        const r = "[" + resp.substring(5) + "]";
        return JSON.parse(r);
      } else {
        const r = "[" + resp.substring(1) + "]";
        return JSON.parse(r);
      }
    }
  };

  private getImageList = async (): Promise<UserSession> => {
    return axios
      .request({
        url: "https://www.artthread.org/Splash2/RetrieveUserImages.php",
        method: "GET",
        withCredentials: true,
      })
      .then((resp) => {
        return resp.data;
      })
      .catch((e) => console.log(e));
  };

  private setMockSession = (
    dispatch: (action: dispatchAction) => void,
    imageList: string[]
  ) => {
    const mockSession = {
      response_code: 200,
      response_desc: "",
      session: "",
      user_id: "",
    };

    dispatch({
      type: "set_session",
      value: mockSession,
    });

    dispatch({
      type: "set_imageList",
      value: imageList,
    });

    const dummyBrushes = require("../Assets/testBrushes.json");

    dispatch({
      type: "set_user_brushes",
      value: dummyBrushes,
    });
  };


  private getMovieAuth = async (token: string) => {
    const endpoint =
      process.env.NODE_ENV === "development"
        ? "http://localhost:8080/auth"
        : "http://147.182.191.149:8080/auth";
    return axios
      .request({
        url: endpoint + "?id=" + token,
        method: "GET",
      })
      .then((resp) => {
        return resp.data;
      })
      .catch((e) => console.log(e));
  };


  public setMovieAuth = async () => {
    const token = (Math.random() + 1).toString(36).substring(7);
    return await this.getMovieAuth(token);
  };


  public initializeSession = async (
    dispatch: (action: dispatchAction) => void,
    isLoggedIn: boolean
  ) => {

    this.setMovieAuth().then((resp) => {
      dispatch({ type: "set_movie_auth", value: resp });
    });

    if( isLoggedIn ) {
      try {       
        const defaultSetting = await fetchDefaultSetting();
        dispatch({ type: "set_user_settings", value: defaultSetting });
        getUserImages().then((resp) => {
          dispatch({ type: "set_imageList", value: resp });
        });
      } catch ( e: any ) {
        console.info(` error fetching default tag`)
      }
    }



  };

  public deleteUserBrush = async (newBrushes: string) => {
    return axios
      .post("https://www.artthread.org/Splash2/UpsertBrush.php", newBrushes, {
        headers: { "Content-Type": "application/json" },
      })
      .then((resp) => {
        console.log(resp);
      });
  };

  public getBrushes = async () => {
    if (process.env.NODE_ENV !== "development") {
      const resp = await api.getUserBrushes();
      if (resp.response_code === 200) {
        return resp;
      }
      return undefined;
    }
  };


  public getUserImages = async (dispatch: (session: UserSession) => void) => {
    if (process.env.NODE_ENV === "development") {
      return this.testImages;
    }

    const resp = await api.getImageList();
    return resp;
  };
}

const api = new API();
export default api;
